import api from '@/api/role'
import { errorHandler } from '../exports/error_management'

import { StorageCache } from '../exports/dataStorage'
const storageKey = 'ams-roles-key'

const state = {
    item: null,
    items: [],
    pagination: null,
}

const mutations = {
    set_item(state, payload) {
        state.item = payload
    },
    set(state, payload) {
        state.items = payload
    },
    delete(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
        console.log('deleted item at index ' + index)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
}

const actions = {
    async create(context, payload) {
        new StorageCache(storageKey).reset()
        await api.create(payload)
    },

    async fetch(context, payload) {
        try {
            const {
                data: {
                    success: { data: pag },
                },
            } = await api.fetch(payload.query, payload.page)

            let items = pag.data

            context.commit('set', items)
            //let pag = result.data.success.data
            context.commit('set_pagination', {
                page: pag.current_page,
                pageSize: pag.per_page,
                total: pag.total,
            })
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchAll(context) {
        const storageCache = new StorageCache(storageKey)
        try {
            const { is_valid, value } = storageCache.getArray()
            if (!is_valid) {
                const {
                    data: {
                        success: { data },
                    },
                } = await api.fetchAll()

                console.log('role data', data)
                storageCache.set(data)
                value.splice(0)
                value.push(...data)
            }
            context.commit('set', value)
        } catch (err) {
            errorHandler(err)
        }
    },
    fetchById(context, id) {
        console.log('id', id)
        return api
            .fetchById(id)
            .then(
                ({
                    data: {
                        success: { data },
                    },
                }) => {
                    console.log('assumed role', data)
                    context.commit('set_item', data)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    update(context, payload) {
        new StorageCache(storageKey).reset()
        return api
            .update(payload.id, payload)
            .then(() => { })
            .catch(err => {
                errorHandler(err)
            })
    },
    delete(context, id) {
        console.log('deleting',id)
        new StorageCache(storageKey).reset()
        return api
            .delete(id)
            .then(() => {
                context.commit('delete', id)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
}

const getters = {
    roles(state) {
        return state.items
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
